import React from 'react';

export const ArtGallery = () => {
    return (<></>)
}